import React, {ReactElement, useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {ApplicationState} from "../store";
import {LayoutState, RectanglePercentInterface} from "../store/layouts/types";
import {setCheckedPane, shutAlllists} from "../store/layouts/actions";
import LiveLayoutComponent from "../components/livemode/LiveLayoutComponent";


interface Props {
    children: ReactElement<any>
}

const LayoutLiveContainer:React.FC<Props> = ({ children }) => {
    const { checkedPane, expandedVideoLayout, currentLayout } = useSelector<ApplicationState, LayoutState>(state => state.layouts);
    const dispatch = useDispatch();
    const [positions, setPositions] = useState<RectanglePercentInterface[]>([]);

    useEffect(() => {
        const newPositions = currentLayout.camerasPositions ? currentLayout.camerasPositions : [];
        setPositions(newPositions)
    }, [currentLayout]);

    const paneHandler = (e: React.MouseEvent, pane: number) => {
        if (checkedPane === pane) return dispatch(shutAlllists());
        dispatch(setCheckedPane(pane))
    };

    return (
        <LiveLayoutComponent    positions={positions}
                                expandedVideoLayout={expandedVideoLayout}
                                checkedPane={checkedPane}
                                handler={paneHandler}
                                children={children}
        />
    )
};

export default LayoutLiveContainer